$(window).on("scroll", function () {
	if ($(window).scrollTop() > 66) {
		$(".header_social_media_wrapper").addClass("no-fixed");
	} else {
		$(".header_social_media_wrapper").removeClass("no-fixed");
	}
});
 $(document).ready(function(){
    $('.slider__item__wrap').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
   $('.tab-ad-title a').click(function(){
    $('.tab-ad-title a').removeClass('active');
    $(this).addClass('active');
    var tagid = $(this).data('tag');
    $('.tab-ad-content').removeClass('active').addClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
  });
   $('#sustainable_score_btn').click(function(){
    $('.tab-ad-title a').removeClass('active');
    $(this).addClass('active');
     var tagid = $(this).data('tag');
    $('.tab-ad-content').removeClass('active').addClass('hide');
    $('[data-tag="three"]').addClass('active').removeClass('hide');
    $('#three.tab-ad-content').addClass('active').removeClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
    $('html, body').animate({
        scrollTop: $('#sustainable_accordion').offset().top
    }, 1000); // Duration in milliseconds
  });
   $('.lifetime_plastic_avoided').click(function(){
    $('.tab-ad-title a').removeClass('active');
    $(this).addClass('active');
     var tagid = $(this).data('tag');
    $('.tab-ad-content').removeClass('active').addClass('hide');
    $('[data-tag="four"]').addClass('active').removeClass('hide');
    $('#four.tab-ad-content').addClass('active').removeClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
    $('html, body').animate({
        scrollTop: $('#lifetime_plastic_avoided').offset().top
    }, 1000); // Duration in milliseconds
  });
   $('.switching_savings_costs').click(function(){
    $('.tab-ad-title a').removeClass('active');
    $(this).addClass('active');
     var tagid = $(this).data('tag');
    $('.tab-ad-content').removeClass('active').addClass('hide');
    $('[data-tag="four"]').addClass('active').removeClass('hide');
    $('#four.tab-ad-content').addClass('active').removeClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
    $('html, body').animate({
        scrollTop: $('#switching_savings_costs').offset().top
    }, 1000); // Duration in milliseconds
  });
   $('.chemicals_avoided').click(function(){
    $('.tab-ad-title a').removeClass('active');
    $(this).addClass('active');
     var tagid = $(this).data('tag');
    $('.tab-ad-content').removeClass('active').addClass('hide');
    $('[data-tag="four"]').addClass('active').removeClass('hide');
    $('#four.tab-ad-content').addClass('active').removeClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
    $('html, body').animate({
        scrollTop: $('#chemicals_avoided').offset().top
    }, 1000); // Duration in milliseconds
  });
});
// Ken - Why was this placed here? It caused an error where no code further below was executed.
//switching_savings_costs
//chemicals_avoided

if (document.querySelector('.main-blog-medium')) {
  function load_medium_posts() {
    var containers = document.querySelectorAll('.main-blog-medium');
    containers.forEach(function(container) {
      var rss_url = container.dataset.rssUrl;
      var media_height = container.dataset.mediaHeight;
      var show_image = (container.dataset.showImage === 'true');
      var show_date = (container.dataset.showDate === 'true');
      var show_author = (container.dataset.showAuthor === 'true');
      var show_excerpt = (container.dataset.showExcerpt === 'true');
      var articles_container = container.querySelector('.blog-articles');
      var template_container = container.querySelector('template');
      var articles_array = [];
      var articles_doc = document.createDocumentFragment();
      var clone_loaded_count = 0;

      fetch('https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(rss_url)).then(function(response) {
        return response.json();
      }).then(function(data) {
        Object.keys(data.items).forEach(function(key, index) {
          var item = data.items[key];
          var image = item.content.match(/<img[^>]+src="([^">]+)"/)[1];
          var link = item.link.split('?')[0];
          var title = item.title;
          var date = new Date(item.pubDate).toLocaleDateString('en-us', { year: 'numeric', month: 'long', day: 'numeric' });
          var author = item.author;
          var content = item.content.replace(/(<([^>]+)>)/gi, '').split(' ').splice(0, 20).join(' ') + '…';
          var clone = template_container.content.cloneNode(true);
          var targets = clone.querySelectorAll('.card__content');

          if (show_image) { clone.querySelector('.article-card__image img').setAttribute('src', image); }
          targets.forEach(function(target) {
            target.querySelector('.card__heading a').setAttribute('href', link);
            target.querySelector('.card__heading a').innerHTML = title;
            if (show_date) { target.querySelector('.article-card__info .circle-divider').innerHTML = date; }
            if (show_author) { target.querySelector('.article-card__info :not(.circle-divider)').innerHTML = author; }
            if (show_excerpt) { target.querySelector('.article-card__excerpt').innerHTML = content; }
          });
          if (show_image) {
            var img = new Image();
            img.src = image;
            img.onload = function() {
              var width = img.naturalWidth;
              var height = img.naturalHeight;
              var ratio_percent = (1 / (width > height ? width / height : height / width) * 100) + '%';
              clone.querySelector('.article-card').style.setProperty('--ratio-percent', ratio_percent);
              clone.querySelector('.card__inner').style.setProperty('--ratio-percent', ratio_percent);
              if (media_height === 'adapt')
                clone.querySelector('.article-card__image').style.paddingBottom = ratio_percent;
              clone_loaded_count++;
              articles_array[index] = clone;
              if (clone_loaded_count >= data.items.length) {
                articles_array.forEach(function(article) { articles_doc.appendChild(article); });
                articles_container.innerHTML = '';
                articles_container.appendChild(articles_doc);
                articles_container.classList.remove('invisible');
              }
            }
          }
          else {
            clone_loaded_count++;
            articles_array[index] = clone;
            if (clone_loaded_count >= data.items.length) {
              articles_array.forEach(function(article) { articles_doc.appendChild(article); });
              articles_container.innerHTML = '';
              articles_container.appendChild(articles_doc);
              articles_container.classList.remove('invisible');
            }
          }
        });
      }).catch(function(error) {
        console.log(error);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', load_medium_posts);
  document.addEventListener('shopify:section:load', load_medium_posts);
}